import { Text } from "@portal/components/primitives";
import type { ReactNode } from "react";

export const MarketAnalyticsSection = ({
	title,
	subtitle,
	testId,
	children,
}: {
	title: string;
	subtitle?: string;
	testId?: string;
	children: ReactNode;
}) => (
	<section
		className="flex shrink-0 flex-col overflow-hidden rounded-md border border-bc-default"
		data-testid={testId}
	>
		<div className="flex items-baseline justify-between gap-3 border-b border-bc-default bg-surface-light px-4 py-2.5">
			<Text type="body-strong" color="primary">
				{title}
			</Text>
			{subtitle !== undefined && (
				<Text type="caption" color="tertiary">
					{subtitle}
				</Text>
			)}
		</div>
		<div className="p-4">{children}</div>
	</section>
);
